export default "__VITE_ASSET__BLeEGw2W__"